import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import some from 'lodash/some';
import { Editor } from '@tinymce/tinymce-react';

import { TabMenu } from 'primereact/tabmenu';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';

import SideBarKeys from '@components/Email/Form/SideBarKeys';
import JustificationModal from '@components/JustificationModal';

import { LANGUAGE_DEFAULT, settingEditorEmail } from '@constants/general';
import { SET_VALUES_EMAIL } from '@constants/actionType';


import store from '@store';

let settingEditor = settingEditorEmail

const POSITION_TR_IMG_ICON = 2

class GeneralForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: 0,
      loadingPage: true,
      errors: {},
      showSideBar: true,
      removeRenderTabs: false,

      descripcion: '',
      nombre: '',
      estatus: 0,
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
    };
    this.initialValuesForm = {
      asunto: '',
      plantilla: '',
    };
  }
  
  componentDidMount() {
    const {
      keysLenguages,
      _general,
      isFullAdmin
    } = this.props;
    if (_general) {
      this.setState({
        ..._general
      })
      if (!_general[LANGUAGE_DEFAULT].plantilla) keysLenguages.map((item) => this.setState((prevState) => ({ [item]: { ...prevState[item], plantilla: "" } })));
    }else {
      keysLenguages.map((item) => this.setState({ [item]: { ...this.initialValuesForm } }));
    }
    keysLenguages.map(item => this.[`plantilla${item}`] = React.createRef())

    if (!isFullAdmin) {
      settingEditorEmail.plugins = settingEditorEmail.plugins.map((item) => {
        if (item.includes('code')) item = item.replace('code', '')
        return item
      })
    }
    this.setState({ loadingPage: false });
  }

  onSubmit = async (e) => {
    if (e) e.preventDefault();
    const { t, success } = this.props
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    console.log('Submit')
    await this.setValuesToStateGlobal();
    return this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => success(justification),
      },
    });
  }

  validateFields = async () => {
    const { t, isEdit } = this.props
    const { descripcion, nombre } = this.state
    const { plantilla, asunto } = this.state[LANGUAGE_DEFAULT]
    let errors = {}
    if (!asunto) errors = {...errors, [`${LANGUAGE_DEFAULT}-asunto`]: `${t('Asunto')} ${t('es requerido')}`}
    if (!plantilla) errors = {...errors, [`${LANGUAGE_DEFAULT}-plantilla`]: `${t('Plantilla')} ${t('es requerido')}`}
    if (!descripcion) errors = {...errors, [`descripcion`]: `${t('Descripcion')} ${t('es requerido')}`}
    if (!nombre && !isEdit) errors = {...errors, [`nombre`]: `${t('Nombre')} ${t('es requerido')}`}
    this.setState({errors})
    return errors
  }

  setValuesToStateGlobal = async () => {
    const { keysLenguages } = this.props;
    const { descripcion, nombre, estatus } = this.state;

    const getValues = keysLenguages.reduce((accum, item) => {
      let values = this.state[item]
      accum[item] = values;
      return accum;
    }, {});

    await store.dispatch({
      type: SET_VALUES_EMAIL,
      payload: {
        general: {
          nombre,
          estatus,
          descripcion,
          ...getValues
        },
      },
    });
    return true
  };


  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeSimple = ({ target }) => {
    if (target.name === 'nombre' && target.value) target.value = target.value.toUpperCase()
    this.setState({[target.name]: target.value}, () => this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  onShowSideBarKeys = (value) => {
    this.setState({showSideBar: value})
  }

  onChangeTab = (e) => {
    this.setState({ activeTabIndex: e.index })
  }
  
  onBlurEditor = (prefixLenguage) => {
    const { keysLenguages, isEdit } = this.props
    this.onChange({target: {name: `${prefixLenguage}-plantilla`, value:  this.[`plantilla${prefixLenguage}`].current.getContent()}})
    // if (!isEdit) {
      keysLenguages.map(key => {
        if (key !== prefixLenguage && !this.state[key].plantilla) {
          this.onChange({target: {name: `${key}-plantilla`, value:  this.[`plantilla${prefixLenguage}`].current.getContent()}})

        }
      })
    // }
  }

  onChangeTab = (e) => {
    this.setState({removeRenderTabs: true})
    setTimeout(() => {
      this.setState({removeRenderTabs: false, activeTabIndex: e.index})
    }, 50);
  }

  onEditIconsOnTemplate = (icon) => {
    const { keysLenguages, t } = this.props
    keysLenguages.map(key => {
      if ( this.state[key].plantilla) {
        const temp = document.createElement('div');
        temp.innerHTML = this.state[key].plantilla;
        const contentTrIcon = temp.querySelectorAll('tr')[POSITION_TR_IMG_ICON];
        const hasImg = contentTrIcon.querySelector('img')
        if (!hasImg) return this.toast.show({
          severity: 'error',
          summary: t('Ha ocurrido un error'),
          detail: t('La plantilla que desea actualziar no cumple con el estandar de plantillas de correos'),
          life: 3000,
        });
        hasImg.setAttribute("src", icon.url)
        hasImg.setAttribute("width", icon.width)
        hasImg.setAttribute("height", icon.height)
        this.onChange({target: {name: `${key}-plantilla`, value:  temp.outerHTML}})
      }
    })
    return this.onShowSideBarKeys(false)
  }
  
  render() {
    const {
      t,
      itemsTabsLenguages,
      keysLenguages,
      history,
      btnSubmitLoading,
      isEdit,
      isFullAdmin
    } = this.props;

    const {
      loadingPage,
      errors,
      activeTabIndex,
      showSideBar,
      removeRenderTabs,
      showModalJustification,
    } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      return (
        <>
          <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              {t('Asunto', {lng: prefixLenguage })}
            </label>
            <InputText
              name={`${prefixLenguage}-asunto`}
              type="text"
              value={this.state[prefixLenguage].asunto}
              onChange={this.onChange}
              autoFocus
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-asunto`),
              })}
              maxLength={70}
            />
            {getFormErrorMessage(`${prefixLenguage}-asunto`)}
          </div>
          <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              {t('Plantilla', {lng: prefixLenguage })}
            </label>
            { !isEdit && (
              <p>
                {t('Para seleccionar un layout predefinido da click en Insert > insert template y elige la plantilla', {lng: prefixLenguage })}
              </p>
            )}
            <div className={classNames({
                'p-invalid-editor': isFormFieldValid(`${prefixLenguage}-plantilla`),
              })}>
            { isFullAdmin  ? (
              <Editor
                // tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                apiKey={process.env.API_KEY_TINY}
                onInit={(evt, editor) => this.[`plantilla${prefixLenguage}`].current = editor}
                onBlur={() => this.onBlurEditor(prefixLenguage)}
                initialValue={this.state[prefixLenguage].plantilla}
                init={{...settingEditorEmail}}
                className="prueba"
              />

            ) : (
              <Editor
                tinymceScriptSrc={'/tinymce/tinymce.min.js'}
                onInit={(evt, editor) => this.[`plantilla${prefixLenguage}`].current = editor}
                onBlur={() => this.onBlurEditor(prefixLenguage)}
                initialValue={this.state[prefixLenguage].plantilla}
                init={{...settingEditorEmail}}
                className="prueba"
              />
            )}


            {getFormErrorMessage(`${prefixLenguage}-plantilla`)}

            </div>
          </div>
        </>
      );
    }

    if (loadingPage) return true;

    return (
      <>
        <form onSubmit={this.onSubmit} autoComplete="false">
          <div className="p-fluid p-grid p-mb-4">
            { isFullAdmin && (
              <div className="p-col-12 p-text-right">
                <p htmlFor="title" className="p-text-bold">
                  {t('Estatus')}
                </p>
                <InputSwitch
                  name={`estatus`}
                  checked={this.state.estatus}
                  onChange={this.onChangeSimple}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`estatus`),
                  })}
                />
              </div>
            )}
            <div className="p-col-12 p-md-4 p-lg-4 p-field">
              <label htmlFor="title" className="p-text-bold">
                {t('Nombre')}
              </label>
              <InputText
                name={`nombre`}
                type="text"
                value={this.state.nombre}
                onChange={this.onChangeSimple}
                autoFocus
                keyfilter="alpha"
                className={classNames({
                  'p-invalid': isFormFieldValid(`nombre`),
                })}
                disabled={isEdit}
                maxLength={50}
              />
              {getFormErrorMessage(`nombre`)}
            </div>
            <div className="p-col-8 p-field">
              <label htmlFor="title" className="p-text-bold">
                {t('Descripcion')}
              </label>
              <InputText
                name={`descripcion`}
                type="text"
                value={this.state.descripcion}
                onChange={this.onChangeSimple}
                autoFocus
                className={classNames({
                  'p-invalid': isFormFieldValid(`descripcion`),
                })}
                maxLength={100}
              />
              {getFormErrorMessage(`descripcion`)}
            </div>
            <div className="p-col-12">
              {itemsTabsLenguages && (
                <TabMenu
                  model={itemsTabsLenguages}
                  activeIndex={activeTabIndex}
                  onTabChange={this.onChangeTab}
                  // onTabChange={(e) => this.setState({ activeTabIndex: e.index })}
                />
              )}
            </div>
            {!removeRenderTabs && renderByTabLenguage()}
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Cancelar')}
                type="button"
                className="p-button-secondary"
                onClick={() => history.push('/emails')}
              />
              <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              />
            </div>
          </div>

        </form>
        {!showSideBar && (
          <div className="layout-config">
            <div className="layout-config-content-wrapper">
            {/* p-button p-component p-button-rounded layout-config-button p-button-secondary p-button-icon-only */}
              <button
                className="layout-config-button p-link p-button-rounded p-button p-component p-button-rounded"
                type="button"
                onClick={() => this.onShowSideBarKeys(true)}
              >
                <i className="pi pi-key" style={{"fontSize": "22px"}}/>
              </button>
            </div>
          </div>
        )}
        <SideBarKeys
          visible={showSideBar}
          onhide={this.onShowSideBarKeys}
          onIconSelect={this.onEditIconsOnTemplate}
        />
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.setState({showModalJustification: { isVisible: false }})}
          onContinueAction={showModalJustification.continueAction}
        />
        <Toast ref={(el) => (this.toast = el)} />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  isFullAdmin: state.settings.isFullAdmin,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  _general: state.email.general
});

const mapDispatchToProps = {
};


export default withRouter(compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(GeneralForm));
